var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTenge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Tenge_Sym"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Tenge_Sym",
    clipPath: "url(#clip-Tenge_Sym)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1",
    d: "M.46-9.12v-1.64H10.64v1.64H6.42V0H4.68V-9.12Zm0-3.18v-1.64H10.64v1.64Z",
    transform: "translate(2.45 14.97)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTenge);
export default __webpack_public_path__ + "static/media/tenge.8911c914.svg";
export { ForwardRef as ReactComponent };